import type { TFunction } from "i18next";
export const SAFETY_RECALL_MESSAGE = (t: TFunction) => t("constants_desc");